(function () {
  function getQty(form) {
    let q = form.querySelector('input[name="quantity"]')
      || document.querySelector(`input[form="${form.id}"][name="quantity"]`);
    return Math.max(1, parseInt(q?.value || '1', 10));
  }

  // NEW: obter o nome do produto para mostrar no carrinho
  function getProductTitle(scope) {
    // tenta dentro do bloco do produto
    const h = (scope || document).querySelector('.product__title h1, .product__title .h1');
    if (h && h.textContent) return h.textContent.trim();
    // fallback para <title> (antes do " – {shop}")
    return document.title.split(' – ')[0].trim();
  }

  function wireForm(form) {
    const scope = form.closest('.product-form')?.parentElement || form.parentElement || document;
    const block = scope.querySelector('[data-engraving]');
    if (!block) return;

    const toggle = block.querySelector('[data-engraving-toggle]');
    const input  = block.querySelector('[data-engraving-text]');
    const wrap   = block.querySelector('[data-engraving-input-wrap]');
    const count  = block.querySelector('[data-engraving-count]');
    const addonVariant = block.getAttribute('data-addon-variant');

    if (!addonVariant) return;

    // garantir que o input “pertence” ao form (para validação nativa)
    if (input && !input.getAttribute('form')) input.setAttribute('form', form.id);

    // contador
    input?.addEventListener('input', () => {
      if (count) count.textContent = `${input.value.length}/${input.maxLength || 15}`;
      input.setCustomValidity('');
    });

    // toggle mostra/esconde + required
    toggle?.addEventListener('change', () => {
      const on = toggle.checked;
      if (wrap) wrap.style.display = on ? '' : 'none';
      if (on) {
        input?.setAttribute('required', 'required');
        setTimeout(() => input?.focus(), 0);
      } else {
        input?.removeAttribute('required');
        if (input) {
          input.value = '';
          input.setCustomValidity('');
          if (count) count.textContent = `0/${input.maxLength || 15}`;
        }
      }
    });

    // Handler de SUBMIT (capture = true para correr antes do tema)
    async function onSubmit(ev) {
      // validação: checkbox ligada mas sem texto
      const needs = !!toggle?.checked;
      const txt = (input?.value || '').trim();

      if (needs && txt.length === 0) {
        ev.preventDefault();
        ev.stopImmediatePropagation(); // bloqueia outros listeners
        if (input) {
          input.setCustomValidity('Please enter your engraving.');
          if (!input.reportValidity?.()) input.focus();
        }
        return;
      }

      // Se não precisa engraving, deixa o tema tratar (não fazemos nada)
      if (!needs) return;

      // A partir daqui tratamos nós o submit (produto + serviço) e impedimos o tema
      ev.preventDefault();
      ev.stopImmediatePropagation();

      if (form.__submitting) return;
      form.__submitting = true;
      const btn = form.querySelector('[type="submit"]');
      btn?.setAttribute('disabled', 'disabled');

      try {
        const eyewearId = form.querySelector('input[name="id"]')?.value;
        if (!eyewearId) throw new Error('Variant id not found');
        const quantity = getQty(form);

        // NEW: título do produto para a propriedade "For"
        const productTitle = getProductTitle(scope);

        const items = [
          { id: Number(eyewearId), quantity },
          {
            id: Number(addonVariant),
            quantity,
            properties: {
              Engraving: txt,
              // NEW: associa ao modelo no carrinho
              For: productTitle
            }
          }
        ];

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
          const msg = form.closest('product-form')?.querySelector('.product-form__error-message');
          if (wrapper && msg) {
            msg.textContent = data?.description || 'Could not add to cart.';
            wrapper.hidden = false;
          } else {
            alert(data?.description || 'Could not add to cart.');
          }
          return;
        }

        // sucesso -> ir para o carrinho (ou abre o drawer se preferires)
        const cartUrl = window.routes?.cart_url || '/cart';
        window.location.href = cartUrl;
      } catch (e) {
        console.error(e);
        alert('Something went wrong adding to cart.');
      } finally {
        form.__submitting = false;
        btn?.removeAttribute('disabled');
      }
    }

    // OUVE EM CAPTURE PARA GARANTIR BLOQUEIO
    form.addEventListener('submit', onSubmit, true);
  }

  function init() {
    document
      .querySelectorAll('form[data-type="add-to-cart-form"]')
      .forEach(wireForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ===== MIREYE — Swatch preview STICKY + Faixa horizontal das swatches (blindado) =====
(() => {
  const CARD   = '.product-card-wrapper';
  const LIST   = '.card-swatch-list';
  const SWATCH = '.card-swatch';
  const IMG0   = '.card__media .media img:first-of-type';
  const MEDIA  = '.card__media';
  const TITLE  = '.card__heading';
  const PRICE  = '.price';
  const ALLOW  = `${MEDIA}, ${TITLE}, ${PRICE}`;

  const BAND_PAD = 6; // altura extra acima/abaixo da faixa

  const cardOf = el => el?.closest?.(CARD) || null;
  const img0Of = card => card?.querySelector(IMG0) || card?.querySelector('.media--hover-effect > img:first-child, .media--hover-effect picture:first-child img') || null;

  // ---------- helpers ----------
  function preload(src){
    return new Promise(res => {
      if (!src) return res(false);
      const im = new Image(); im.src = src;
      if (im.decode) im.decode().then(()=>res(true)).catch(()=>res(true));
      else if (im.complete) res(true);
      else im.onload = () => res(true);
    });
  }

  // força a primeira imagem a estar visível (corrige “quadro branco”)
  function forcePrimaryVisible(card, on){
    const i0 = img0Of(card);
    if (!i0) return;
    if (on){
      i0.style.setProperty('opacity', '1', 'important');
      i0.style.setProperty('visibility', 'visible', 'important');
      i0.style.setProperty('transform', 'none', 'important');
    } else {
      i0.style.removeProperty('opacity');
      i0.style.removeProperty('visibility');
      i0.style.removeProperty('transform');
    }
  }

  async function swapTo(card, src){
  const img = img0Of(card);
  if (!img || !src) return;

  if (!img.dataset.originalSrc){
    img.dataset.originalSrc    = img.currentSrc || img.src;
    img.dataset.originalSrcset = img.srcset || '';
  }

  await preload(src);

  // --- Fade suave ---
  img.style.opacity = '0'; // fade-out da imagem atual

  requestAnimationFrame(() => {
    img.setAttribute('loading', 'eager');
    img.srcset = '';
    img.src    = src;

    requestAnimationFrame(() => {
      img.style.opacity = '1'; // fade-in da nova imagem
    });
  });

  // manter sticky
  card.__stickyVariantSrc = src;
  card.__lastVariantSrc   = src;
  card.classList.add('swatch-preview-active','swatch-suppress');
  forcePrimaryVisible(card, true);
}


  function showLastVariant(card){
    if (!card?.__lastVariantSrc) return;
    const img = img0Of(card);
    if (img && img.src !== card.__lastVariantSrc){
      img.srcset = '';
      img.src    = card.__lastVariantSrc;
    }
  }

  function restore(card){
    const img = img0Of(card);
    if (img && img.dataset.originalSrc){
      img.src    = img.dataset.originalSrc;
      img.srcset = img.dataset.originalSrcset || '';
    }
    delete card.__stickyVariantSrc;
    // mantém __lastVariantSrc para voltar a mostrá-la quando reentrar na faixa
    card.classList.remove('swatch-preview-active', 'swatch-suppress', 'in-swatch-band');
    forcePrimaryVisible(card, false);
  }

  // ===== faixa horizontal (y-only) =====
  function getSwatchBand(card){
    const list = card.querySelector(LIST); if (!list) return null;
    const lr = list.getBoundingClientRect();
    return [lr.top - BAND_PAD, lr.bottom + BAND_PAD]; // [top, bottom]
  }
  function isInBand(card, y){
    const band = getSwatchBand(card);
    return band && y >= band[0] && y <= band[1];
  }

  // ===== eventos =====
  // Hover numa swatch → troca imediata (sem timers)
  document.addEventListener('pointerenter', e => {
    const sw = e.target.closest?.(SWATCH); if (!sw) return;
    const card = cardOf(sw); if (!card) return;
    swapTo(card, sw.getAttribute('data-image-src'));
  }, true);

  // Movimentos dentro do card → gerir faixa e supressão da 2.ª imagem
  document.addEventListener('pointermove', e => {
    const card = cardOf(e.target); if (!card) return;

    const inBand    = isInBand(card, e.clientY);
    const overAllow = !!e.target.closest?.(ALLOW);

    if (inBand){
      // Na faixa: bloqueia 2.ª imagem e cola a última variante
      if (!card.classList.contains('in-swatch-band')){
        card.classList.add('in-swatch-band');
      }
      card.classList.add('swatch-suppress');
      showLastVariant(card);
      forcePrimaryVisible(card, true);
      return;
    }

    // Fora da faixa:
    card.classList.remove('in-swatch-band');

    if (overAllow){
      // Em cima de imagem/título/preço → deixa o tema mostrar a 2.ª
      card.classList.remove('swatch-suppress');
      forcePrimaryVisible(card, false);
    } else {
      // “brancos” fora da faixa → mantém a última variante, sem 2.ª imagem
      if (card.__lastVariantSrc){
        card.classList.add('swatch-suppress');
        showLastVariant(card);
        forcePrimaryVisible(card, true);
      } else {
        // nada guardado: liberta
        card.classList.remove('swatch-suppress');
        forcePrimaryVisible(card, false);
      }
    }
  }, true);

  // Entrar em imagem/título/preço → permitir 2.ª imagem só fora da faixa
  document.addEventListener('pointerenter', e => {
    const allow = e.target.closest?.(ALLOW); if (!allow) return;
    const card = cardOf(allow); if (!card) return;
    if (isInBand(card, e.clientY)) return;          // na faixa nunca
    card.classList.remove('swatch-suppress');
    forcePrimaryVisible(card, false);
  }, true);

  // Sair do card → reset total
  document.addEventListener('pointerleave', e => {
    const card = e.target.closest?.(CARD); if (!card) return;
    restore(card);
  }, true);

  // Acessibilidade: Tab em swatch → também troca
  document.addEventListener('focusin', e => {
    const sw = e.target.closest?.(SWATCH); if (!sw) return;
    const card = cardOf(sw); if (!card) return;
    swapTo(card, sw.getAttribute('data-image-src'));
  });
  document.addEventListener('focusout', e => {
    const card = e.target.closest?.(CARD);
    if (!card || card.contains(e.relatedTarget)) return;
    restore(card);
  });

  // Click numa swatch → troca e mantém sticky
  document.addEventListener('click', e => {
    const sw = e.target.closest?.(SWATCH); if (!sw) return;
    const card = cardOf(sw); if (!card) return;
    swapTo(card, sw.getAttribute('data-image-src'));
  });

  // Init
  function init(){
    document.querySelectorAll(CARD).forEach(card => {
      if (card.querySelector(LIST)) card.classList.add('has-swatches');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  new MutationObserver(m => m.forEach(mu => mu.addedNodes?.forEach(n => { if (n instanceof Element) init(); })))
    .observe(document.documentElement, { childList:true, subtree:true });
})();


